export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <section className="relative bg-ds-creamalt overflow-hidden border-b border-ds-plum/10">
      <div className="contour absolute inset-0" aria-hidden="true" />
      <div className="container-x relative py-14 sm:py-20 max-w-4xl">
        <p className="text-sm font-semibold text-ds-plum">{eyebrow}</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.1] text-ds-plumdeep" data-testid="page-title">{title}</h1>
        <svg className="mt-4 w-36 h-3 text-ds-amber" viewBox="0 0 144 12" fill="none" aria-hidden="true"><path d="M3 8 C36 3 90 3 141 6" stroke="currentColor" strokeWidth="3" strokeLinecap="round" /></svg>
        {subtitle && <p className="mt-5 text-[17px] sm:text-lg text-ds-inksoft max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}
